import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  props: {
    itemData: Object,
  },
  data() {
    return {
      user: this.$store.state.user,
      allUsers: [],
      users: [],
      role: "",
      id: "",
      searchTerm: "",
      searchOpen: false,
      state: "",
      name: "",
      email: "",
      message: "",
      error: false,
      deleteRole: true,
      isLoading: false,
    };
  },
  created() {
    if (this.itemData) {
      this.id = this.itemData.id;
      this.role = this.itemData.name;

      this.getAllUsers(this.id);
    }
  },
  methods: {
    /**
     * Get the users for the current role
     * @param id
     */
    getAllUsers(id) {
      this.isLoading = true;

      this.$axios.get(baseUrl + "/roleusers?id=" + id).then((response) => {
        this.allUsers = response.data;
        this.users = this.allUsers;

        this.isLoading = false;

        if (this.allUsers.length > 0) {
          this.state = "overview";
        } else {
          this.state = "add";
        }

        // This way the last Administrator can not be deleted
        if (this.role == "Administrator" && this.allUsers.length <= 1) {
          this.deleteRole = false;
        } else {
          this.deleteRole = true;
        }
      });
    },
    /**
     * Search the users on input
     */
    searchUser() {
      if (this.searchTerm === "") {
        this.users = this.allUsers;
      } else {
        var results = [];
        for (var i = 0; i < this.allUsers.length; i++) {
          /* Check if the names match */
          if (
            this.allUsers[i].name
              .toLowerCase()
              .includes(this.searchTerm.toLowerCase())
          ) {
            results.push(this.allUsers[i]);
          }
        }
        this.users = results;
      }
    },
    openRightSidebar(id, data) {
      EventBus.$emit("closeallactions");

      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    /**
     *
     * @param item
     */
    setDelete(item) {
      /*let data = {};
      data.user = item;
      data.user.role = this.role;
      data.close = "open-users-by-role";
      EventBus.$emit("update-user", data);*/

      this.openRightSidebar("roleDelete", item.role);
    },
    /**
     * Delete the current user from the role
     * - Make the user a basic user by removing the role_id
     * @param id
     */
    deleteUser(email) {
      let formData = new FormData();

      formData.append("mail", email);
      formData.append("role_id", "");

      this.$axios
        .post(baseUrl + "/invite", formData)
        .then((response) => {
          if ((response.data = true)) {
            this.open = "overview";
            this.getAllUsers(this.id);
          } else {
            this.error = true;
            this.message = i18n.t("common.something_went_wrong");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
    /**
     * Add a user to the current role
     */
    addUser() {
      let formData = new FormData();

      formData.append("mail", this.email);
      formData.append("role_id", this.id);

      this.$axios
        .post(baseUrl + "/invite", formData)
        .then((response) => {
          if ((response.data = true)) {
            this.open = "overview";
            this.getAllUsers(this.id);
          } else {
            this.error = true;
            this.message = i18n.t("common.something_went_wrong");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
  },
};
